import { replace } from 'react-router-redux';
import { openGlobalModal } from 'actions/modal';
import { getMemberCourseList, getCourseInfo, getCourseRecommend } from 'actions/course';
import { getMemberData } from 'actions/member';

export default store => ({
	path: 'membercourse',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./Home').default;
					cb(null, component);
				},
				'MemberCourse',
			),
		onEnter: () => {
			store.dispatch(getMemberData());
			const { auth: { token: { accessToken } } } = store.getState();
			const { members: { emailVerify } } = store.getState();
			if (accessToken === '') {
				store.dispatch(replace({ pathname: '/login' }));
			} else {
				if (emailVerify === 0) {
					store.dispatch(openGlobalModal('verifyEmailNotyet'));
				}
				store.dispatch(getMemberCourseList());
			}
		},
	},
	childRoutes: [
		{
			path: ':id/cancel',
			indexRoute: {
				getComponent: (nextState, cb) =>
					require.ensure(
						[],
						require => {
							const component = require('./Cancel').default;
							cb(null, component);
						},
						'CourseCancel',
					),
				onEnter: ({ params }) => {
					store.dispatch(getMemberData());
					console.log(params.id);
				},
			},
		},
		{
			path: ':id/result',
			indexRoute: {
				getComponent: (nextState, cb) =>
					require.ensure(
						[],
						require => {
							const component = require('./Result').default;
							cb(null, component);
						},
						'MemberResult',
					),
				onEnter: ({ params }) => {
					store.dispatch(getCourseInfo(params.id));
					store.dispatch(getCourseRecommend(params.id));
				},
			},
		},
	],
});



// WEBPACK FOOTER //
// ./src/routes/MemberCourse/index.js